import React, { useContext } from 'react';
import { isMobile } from 'react-device-detect';
import { Text, View } from '@coinscrap/webapp-core';
import { MainModal } from '../../../components/MainModal/MainModal';
import { SmallButton } from '../../../components/SmallButton/SmallButton';
import { CONFIG } from '../../../config/config';
import routes from '../../../config/config/routes';
import { AgentContext } from '../../../contexts/agent';

export const usePreemissionError = (
	e,
	setTrigger,
	openModal,
	navigateTo,
	isDebug,
	clearSession,
	agent,
) => {
	const asyncClearSession = async (close) => {
		close();
		CONFIG.routing.koReset.koReset(navigateTo, agent.identifier);
	};

	const errorMessage = e?.safeMessage?.toString();
	const errorArray = errorMessage.split('|');
	console.log('💢 errorMessage', errorMessage);
	console.log('💢 errorArray', errorArray);
	let erroresConocidos = [];

	let mostrarRevisarDatosSimulacion = false;
	let mostrarRevisarDatosPoliza = false;
	let mostrarReintentar = false;
	let mostrarRetarificar = false;
	let mostrarReiniciar = false;
	let mostrarContactar = false;
	let mostrarVariousErrors = true;

	if (errorMessage.includes('PE-27|Blockages found')) {
		erroresConocidos.push('BLOCKAGES');
		mostrarContactar = true;
		mostrarVariousErrors = false;
	}
	if (errorMessage.includes('EPEDRWT9-097')) {
		erroresConocidos.push('NECESITA_RETARIFICAR');
		mostrarRetarificar = true;
		mostrarContactar = true;
	}
	if (errorMessage.includes('EPEDRWT9-CP')) {
		erroresConocidos.push('CODIGO_POSTAL_ERRONEO');
		mostrarRevisarDatosSimulacion = true;
		mostrarContactar = true;
	}
	if (errorMessage.includes('EPEDRWT9-000000007')) {
		erroresConocidos.push('ERROR_BENEFICIARIOS');
		mostrarRevisarDatosPoliza = true;
		mostrarContactar = true;
	}
	if (errorMessage.includes('WSEV0001-000002002')) {
		erroresConocidos.push('XML_ENVIADO_INVALIDO');
		mostrarReiniciar = true;
		mostrarContactar = true;
	}
	if (errorMessage.includes('EPEDRWT9-VPE000291')) {
		erroresConocidos.push('FORMATO_INVALIDO');
		mostrarReiniciar = true;
		mostrarContactar = true;
	}
	if (errorMessage.includes('ET1DRWT9-000000003')) {
		erroresConocidos.push('INVALID_DATES');
		mostrarRetarificar = true;
		mostrarContactar = true;
	}
	if (errorMessage.includes('WS-10|')) {
		erroresConocidos.push('ALZ_WS_NOT_AVAILABLE');
		mostrarReintentar = true;
		mostrarContactar = true;
	}
	const totalErrors = errorArray.length - 2;

	openModal(
		(close) => (
			<MainModal type="error">
				<Text headingPrimarySt errorSt>
					{totalErrors > 1 && mostrarVariousErrors
						? 'Se han encontrado varios errores'
						: erroresConocidos.includes('BLOCKAGES')
						? 'Lo sentimos, no es posible continuar con el proceso.'
						: erroresConocidos.includes('XML_ENVIADO_INVALIDO')
						? 'Ha ocurrido un error. Reinicie el proceso por favor.'
						: erroresConocidos.includes('FORMATO_INVALIDO')
						? 'Ha ocurrido un error. Reinicie el proceso por favor.'
						: erroresConocidos.includes('NECESITA_RETARIFICAR')
						? 'El sistema necesita retarificar los importes.'
						: erroresConocidos.includes('CODIGO_POSTAL_ERRONEO')
						? 'El código postal y la población no coinciden.'
						: erroresConocidos.includes('ERROR_BENEFICIARIOS')
						? 'Existen errores en los beneficiarios informados.'
						: erroresConocidos.includes('INVALID_DATES')
						? 'El sistema necesita retarificar los importes.'
						: erroresConocidos.includes('ALZ_WS_NOT_AVAILABLE')
						? 'Ha ocurrido un error. Vuelva a intentarlo pasados unos segundos.'
						: 'Ha ocurrido un error'}
				</Text>

				{isDebug ? (
					<Text errorSt smSt style={{ marginTop: 10 }}>
						👷‍♂️ DEBUG ERROR
					</Text>
				) : null}

				{isDebug && totalErrors > 1 ? (
					errorArray.map((error, index) => {
						if (index === 0 || index === errorArray.length) {
							return null;
						}
						return (
							<Text errorSt smSt>
								{error?.toString()}
							</Text>
						);
					})
				) : isDebug ? (
					<Text errorSt smSt>
						{errorArray[errorArray?.length - 1 ?? 0]?.toString()}
					</Text>
				) : null}
				<View colRowSt style={{ marginTop: 20 }}>
					{mostrarRevisarDatosSimulacion && (
						<SmallButton
							onClick={() => {
								CONFIG.routing.activateProduct.koReviewData(navigateTo);
								close();
							}}
						>
							Revisar datos
						</SmallButton>
					)}
					{mostrarRevisarDatosPoliza && (
						<SmallButton
							onClick={() => {
								navigateTo(routes.clientData, {
									queryParams: { internalStep: 4, editMode: true },
								});
								close();
							}}
						>
							Revisar datos
						</SmallButton>
					)}
					{mostrarReintentar && (
						<SmallButton
							onClick={() => {
								setTrigger((t) => t + 1);
								close();
							}}
						>
							Reintentar
						</SmallButton>
					)}
					{mostrarRetarificar && (
						<SmallButton
							onClick={() => {
								CONFIG.routing.activateProduct.koRetarificate(navigateTo);
								close();
							}}
						>
							Retarificar
						</SmallButton>
					)}
					{mostrarReiniciar && (
						<SmallButton onClick={() => asyncClearSession(close)}>
							Reiniciar proceso
						</SmallButton>
					)}
					{(mostrarContactar ||
						(mostrarRevisarDatosSimulacion === false &&
							mostrarRevisarDatosPoliza === false &&
							mostrarReintentar === false &&
							mostrarRetarificar === false &&
							mostrarReiniciar === false)) && (
						<SmallButton
							onClick={() => {
								if (erroresConocidos.includes('BLOCKAGES')) {
									CONFIG.routing.activateProduct.contactBlockages(navigateTo);
								} else {
									CONFIG.routing.activateProduct.contact(navigateTo);
								}
								close();
							}}
						>
							Contactar
						</SmallButton>
					)}
				</View>
			</MainModal>
		),
		{
			disableClickAway: true,
			closeButton: false,
			modalClass: isMobile ? 'modal-xl' : 'modal-main',
			key: 'modal-Preemission-KO',
		},
	);
};
